export default __webpack_public_path__ + "static/media/autoParts.3794e54a.jpg";